module.exports = __webpack_public_path__ + "img/icon81.67431f66.png";